// GENERATED FILE — DO NOT EDIT MANUALLY.
// Source: data/products/website_catalog.current.json
// Generator: site/migration/generate-prototype-catalog.mjs
window.FSWebsiteCatalog = [
  {
    "sku": "FS-BR-2606-005",
    "featured": true,
    "title": "Clear Quartz & Agarwood Bracelet",
    "titleCn": "静木清光",
    "subtitle": "Quiet Woodlight",
    "productNameEn": "Quiet Woodlight",
    "states": [
      "Clarity",
      "Grounding"
    ],
    "price": "$79",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Clear Quartz, Agarwood",
    "sizeText": "Beads 8-9 mm · S–L · Fits wrists 13–18 cm",
    "color": "Transparent, Brown",
    "gemstone": "Quartz, Wood",
    "collection": "woodlight",
    "primary": "FS-BR-2606-005__white_bg_product__01.png",
    "wear": "FS-BR-2606-005__display__01__site_selected.png",
    "detailImages": [
      "FS-BR-2606-005__white_bg_product__01.png",
      "FS-BR-2606-005__atmosphere__01__site_selected.png",
      "FS-BR-2606-005__atmosphere__03__site_selected.png",
      "FS-BR-2606-005__detail__01__site_selected.png",
      "FS-BR-2606-005__display__01__site_selected.png",
      "FS-BR-2606-005__poster__01__site_selected.png"
    ],
    "oneLineStory": "Clear quartz and dark agarwood alternate in a restrained composition of transparency, warm grain, and open space.",
    "productStory": "Quiet Woodlight pairs clear quartz with agarwood, letting transparency and dark wood grain define the bracelet with very little else. Rounded quartz beads are broken by larger wooden forms and stacked wood details, creating a measured rhythm between brightness and depth.\n\nThe name comes from that contrast: clear light appearing against a quieter field of brown wood. The piece speaks first to Clarity, while the weight, grain, and darker tone of agarwood bring a steadier Grounding note beneath it.",
    "materialDescription": "Made with clear quartz, agarwood, and stainless-steel components, with beads approximately 8–9 mm alongside larger wooden elements. The bracelet combines colourless transparency with deep brown wood grain and varied wooden forms. Natural differences in quartz clarity, internal features, wood colour, and grain may occur between pieces.",
    "stateCopy": "Clarity leads this piece, with Grounding as its secondary note. Transparent quartz keeps the composition open and bright, while the darker agarwood introduces visual weight, texture, and a quieter point of rest.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T06:29:42+00:00",
    "description": "白水晶的清透感像一束落在木色里的清光；木珠的纹理和深浅变化，让这束光有了更安静的底色。"
  },
  {
    "sku": "FS-BR-2606-024",
    "featured": false,
    "title": "Green Phantom Quartz Bracelet",
    "titleCn": "幽翠雪境",
    "subtitle": "Emerald Snowveil",
    "productNameEn": "Emerald Snowveil",
    "states": [
      "Grounding",
      "Protection"
    ],
    "price": "$1099",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Green Phantom Quartz",
    "sizeText": "Beads 8-10 mm · S–L · Fits wrists 13–18 cm",
    "color": "Green, Transparent",
    "gemstone": "Quartz",
    "collection": "emerald-realm",
    "primary": "FS-BR-2606-024__white_bg_product__02.png",
    "wear": "FS-BR-2606-024__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2606-024__white_bg_product__02.png",
      "FS-BR-2606-024__wear__01.png",
      "FS-BR-2606-024__atmosphere__01.png",
      "FS-BR-2606-024__atmosphere__02.png",
      "FS-BR-2606-024__detail__01.png"
    ],
    "oneLineStory": "Transparent quartz holds deep green, grey-black, and misty inclusions, forming a quiet landscape within each rounded bead.",
    "productStory": "Emerald Snowveil is composed entirely of Green Phantom Quartz, with dark green, grey-black, and pale mineral inclusions suspended through transparent beads. Rather than a bright, vivid green, the bracelet carries a cooler and more subdued landscape, with each bead revealing its own shifting concentration of colour and mist.\n\nThe name follows that internal scenery: deep green forms appear through pale crystalline haze like a shadowed mountain landscape under snow mist. It speaks first to Grounding, with a quieter sense of Protection held in its enclosed, layered depth.",
    "materialDescription": "Made entirely with Green Phantom Quartz in a uniform round-bead bracelet. The transparent quartz contains visible green, grey-black, and pale cloudy inclusions in varying concentrations and formations. Transparency, internal pattern, colour density, and the placement of mineral inclusions naturally differ from bead to bead.",
    "stateCopy": "Grounding leads this piece, with Protection as its secondary state. Dense green and darker inclusions give each transparent bead visual depth and weight, while the enclosed landscapes create a more contained, sheltered presence within the otherwise simple strand.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T06:38:27+00:00",
    "description": "深绿、灰黑与白色晶雾在珠体里交错，像一片被雪雾覆盖的幽深山境。它不是鲜亮型绿幽灵，而是更冷、更沉、更有矿物深度的绿境感。"
  },
  {
    "sku": "FS-BR-2607-004",
    "featured": true,
    "title": "Aquamarine & Clear Quartz Bracelet",
    "titleCn": "浅蓝清波",
    "subtitle": "Pale Blue Ripples",
    "productNameEn": "Pale Blue Ripples",
    "states": [
      "Soothing",
      "Clarity"
    ],
    "price": "$99",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Aquamarine, Clear Quartz",
    "sizeText": "Beads 10-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Blue, Transparent",
    "gemstone": "Beryl, Quartz",
    "collection": "moonlit-sea",
    "primary": "FS-BR-2607-004__white_bg_product__01.png",
    "wear": "FS-BR-2607-004__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2607-004__white_bg_product__01.png",
      "FS-BR-2607-004__atmosphere__01.png",
      "FS-BR-2607-004__atmosphere__02.png"
    ],
    "oneLineStory": "Pale aquamarine and clear quartz alternate in a cool, translucent bracelet with softly varied shapes and reflections.",
    "productStory": "Pale Blue Ripples pairs soft blue aquamarine with clear quartz in a light, open composition. Rounded beads are interrupted by a transparent geometric form and smaller faceted details, giving the bracelet a gentle shift in rhythm without disturbing its restrained palette.\n\nThe name follows its quiet blue-and-clear contrast, reminiscent of shallow water after the tide has receded. It speaks first to Soothing, with Clarity present in the transparent spaces and cool white reflections.",
    "materialDescription": "Made with aquamarine and clear quartz in a mixed-shape bracelet, with beads approximately 10–14 mm. The palette moves between pale blue and colourless transparency. Clear quartz shows visible internal features and varied forms, while colour, transparency, and internal details naturally differ between individual stones.",
    "stateCopy": "Soothing leads this piece, with Clarity as its secondary note. Pale blue aquamarine gives the composition a softened, quiet tone, while transparent quartz and cool reflections introduce lighter, more open intervals throughout the bracelet.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T05:43:24+00:00",
    "description": "浅蓝海蓝宝圆珠与透明白水晶交错，色调清浅，像退潮后一片安静的浅水。"
  },
  {
    "sku": "FS-BR-2607-007",
    "featured": true,
    "title": "Kyanite & Obsidian Bracelet",
    "titleCn": "冷蓝星霜",
    "subtitle": "Blue Starfrost",
    "productNameEn": "Blue Starfrost",
    "states": [
      "Clarity",
      "Protection"
    ],
    "price": "$139",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Kyanite, Obsidian, Clear Quartz, Grey Moonstone, Black Gold Super Seven",
    "sizeText": "Beads 10-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Blue, Black, Grey, Transparent",
    "gemstone": "Other, Obsidian, Quartz, Feldspar",
    "collection": "nocturne-cosmos",
    "primary": "FS-BR-2607-007__simple_bg_product__02__site_selected.png",
    "wear": "FS-BR-2607-007__atmosphere__01__site_selected.png",
    "detailImages": [
      "FS-BR-2607-007__simple_bg_product__02__site_selected.png",
      "FS-BR-2607-007__simple_bg_product__01__site_selected.png",
      "FS-BR-2607-007__atmosphere__01__site_selected.png",
      "FS-BR-2607-007__atmosphere__02__site_selected.png"
    ],
    "oneLineStory": "Cool blue, charcoal, and clear stones shift between soft flashes, deep shadows, and crisp transparent facets.",
    "productStory": "Blue Starfrost layers kyanite, obsidian, grey moonstone, clear quartz, and Black Gold Super Seven into a bracelet of cool blue, grey, black, and transparent tones. Rounded stones of varying sizes sit beside clear geometric forms and a small clustered detail, giving the composition a distinctly structured rhythm.\n\nIts name comes from the contrast between night-like blues and the pale flashes that appear across moonstone and clear quartz, like frost catching light after dark. The piece speaks first to Clarity, with a more contained, guarded note beneath it.",
    "materialDescription": "Made with kyanite, obsidian, clear quartz, grey moonstone, and Black Gold Super Seven, with beads approximately 10–14 mm. The bracelet combines rounded stones, transparent geometric quartz forms, and smaller clustered beads. Colour, translucency, surface flash, internal markings, and inclusions naturally vary between individual stones.",
    "stateCopy": "Clarity leads this piece, with Protection as its secondary state. Clear quartz and cool blue tones create brighter visual intervals, while deeper obsidian, grey moonstone, and darker mineral details give the composition a more enclosed, quietly guarded presence.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T05:59:59+00:00",
    "description": "蓝晶石的冷蓝、黑曜石的深黑、灰月光的乳白晕与黑金超七方糖的细光交错，透明白水晶把整串提亮，像夜空下一片带霜的冷水。"
  },
  {
    "sku": "FS-BR-2607-008",
    "featured": false,
    "title": "Rutilated Quartz & Aquamarine Bracelet",
    "titleCn": "浅海含金",
    "subtitle": "Gold in Shallow Waters",
    "productNameEn": "Gold in Shallow Waters",
    "states": [
      "Soothing",
      "Clarity"
    ],
    "price": "$109",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Rutilated Quartz, Aquamarine, Agarwood",
    "sizeText": "Beads 10-12 mm · S–L · Fits wrists 13–18 cm",
    "color": "Blue, Transparent, Gold, Brown",
    "gemstone": "Quartz, Beryl, Wood",
    "collection": "woodlight",
    "primary": "FS-BR-2607-008__white_bg_product__01.png",
    "wear": "FS-BR-2607-008__poster__02.png",
    "detailImages": [
      "FS-BR-2607-008__white_bg_product__01.png",
      "FS-BR-2607-008__atmosphere__04.png",
      "FS-BR-2607-008__atmosphere__05.png",
      "FS-BR-2607-008__poster__02.png",
      "FS-BR-2607-008__poster__04.png"
    ],
    "oneLineStory": "Pale aquamarine, thread-filled quartz, and warm agarwood meet in a cool blue composition touched with gold and brown.",
    "productStory": "Gold in Shallow Waters brings together pale aquamarine, rutilated quartz, and agarwood in a composition of cool blue, transparency, and warm brown. Fine golden threads run through the clear quartz, while the wood beads create darker points of contrast among the softer blue stones.\n\nThe name follows that balance: a quiet, shallow-water palette interrupted by small traces of gold and sun-warmed wood. The piece speaks first to Soothing, with Clarity held in its transparent quartz and lighter blue intervals.",
    "materialDescription": "Made with aquamarine, rutilated quartz, agarwood, and stainless-steel components. The bracelet combines pale blue stones, transparent quartz with visible thread-like inclusions, and warm brown wood beads in varied sizes and forms. Colour, transparency, inclusions, and wood grain naturally vary between individual elements.",
    "stateCopy": "Soothing leads this piece, with Clarity as its secondary note. Soft aquamarine keeps the palette quiet and open, while transparent rutilated quartz adds fine lines of light. Warm agarwood provides a grounded visual counterpoint without overwhelming the cooler composition.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T06:11:57+00:00",
    "description": "浅蓝海蓝宝与带金丝的发晶交错，一颗沉香木珠沉在其中，冷蓝里有一点暖金和木色的落点。"
  },
  {
    "sku": "FS-BR-2607-010",
    "featured": true,
    "title": "Rose Quartz & Clear Quartz Bracelet",
    "titleCn": "轻粉浮光",
    "subtitle": "Soft Blush Gleam",
    "productNameEn": "Soft Blush Gleam",
    "states": [
      "Unfolding",
      "Clarity"
    ],
    "price": "$109",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Rose Quartz, Clear Quartz",
    "sizeText": "Beads 12-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Pink, Transparent, White",
    "gemstone": "Quartz",
    "collection": "rose-mist",
    "primary": "FS-BR-2607-010__white_bg_product__01.png",
    "wear": "FS-BR-2607-010__atmosphere__04__site_selected.png",
    "detailImages": [
      "FS-BR-2607-010__white_bg_product__01.png",
      "FS-BR-2607-010__atmosphere__04__site_selected.png",
      "FS-BR-2607-010__atmosphere__02__site_selected.png",
      "FS-BR-2607-010__atmosphere__03__site_selected.png"
    ],
    "oneLineStory": "Misty rose quartz and clear quartz meet in an irregular rhythm of soft pink, transparency, and shifting light.",
    "productStory": "Soft Blush Gleam brings together rose quartz and clear quartz in deliberately varied shapes and sizes. The beads do not align into a uniform rhythm; instead, pale pink forms, transparent rounds, and fractured interiors create a composition that feels loose and quietly luminous.\n\nIts name comes from what appears as the bracelet turns: mist-like depth within the rose quartz, fine crackled patterns within the clear quartz, and small flashes of light moving across their surfaces. A piece for moments that call for a little more openness and visual clarity.",
    "materialDescription": "Made with rose quartz and clear quartz in a mixed-shape, mixed-size bracelet without metal accessories. The palette moves between pale pink, transparent, and soft white. Visible internal veils, fractures, and variations differ naturally from bead to bead, giving each part of the composition a slightly different appearance.",
    "stateCopy": "Primarily aligned with Unfolding, with Clarity as a secondary note. The irregular spacing, soft pink translucency, and clear fractured quartz hold a sense of looseness and openness, while the brighter transparent elements introduce a cleaner, more defined visual counterpoint.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-10T02:10:28.000Z",
    "description": "大小不一、形状各异的异形粉晶与白水晶，颗颗不对齐；异形粉晶内部像化开的雾，冰裂白水晶里藏着细碎的裂网，转角度时有光线浮出来。"
  },
  {
    "sku": "FS-BR-2607-011",
    "featured": true,
    "title": "Green Phantom Quartz & Fluorite Bracelet",
    "titleCn": "青碧浅泉",
    "subtitle": "Shallow Jade Spring",
    "productNameEn": "Shallow Jade Spring",
    "states": [
      "Clarity",
      "Grounding"
    ],
    "price": "$129",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Green Phantom Quartz, Fluorite, Aquamarine, Clear Quartz",
    "sizeText": "Beads 10-16 mm · S–L · Fits wrists 13–18 cm",
    "color": "Green, Blue, Transparent",
    "gemstone": "Quartz, Other, Beryl",
    "collection": "emerald-realm",
    "primary": "FS-BR-2607-011__white_bg_product__01.png",
    "wear": "FS-BR-2607-011__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2607-011__white_bg_product__01.png",
      "FS-BR-2607-011__simple_bg_product__01.png",
      "FS-BR-2607-011__atmosphere__01.png",
      "FS-BR-2607-011__atmosphere__02.png"
    ],
    "oneLineStory": "Green phantom quartz, pale fluorite, aquamarine, and clear quartz gather in a cool, translucent spectrum of green and blue.",
    "productStory": "Shallow Jade Spring brings together green phantom quartz, fluorite, aquamarine, and clear quartz in shifting shades of green, blue, and transparency. Scenic inclusions sit beside clearer beads, while rounded and irregular forms keep the composition varied and open.\n\nIts name follows the bracelet’s water-like palette: pale green and soft blue moving through clear quartz like a shallow spring seen in light. The piece holds Clarity first, with Grounding beneath it in the deeper green inclusions and denser tones.",
    "materialDescription": "Made with green phantom quartz, fluorite, aquamarine, and clear quartz in a mixed-shape bracelet. Colours range from pale green and blue-green to soft aqua and colourless transparency. Visible inclusions, internal fractures, colour zoning, and differences in translucency vary naturally from stone to stone.",
    "stateCopy": "Clarity leads this piece, with Grounding as its secondary note. Transparent quartz and pale blue-green tones create an open, light visual field, while the deeper green phantom inclusions add denser points of weight and structure within the composition.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-10T07:19:02+00:00",
    "description": "绿幽灵的青绿、绿莹石的浅绿、海蓝宝的浅蓝与透明白水晶交错，像一泓浅碧泉水，绿里带蓝，清透安静。"
  },
  {
    "sku": "FS-BR-2607-012",
    "featured": true,
    "title": "Sandalwood Tube Beads & Smoky Quartz Bracelet",
    "titleCn": "烟木清光",
    "subtitle": "Smoky Woodlight",
    "productNameEn": "Smoky Woodlight",
    "states": [
      "Grounding",
      "Clarity"
    ],
    "price": "$99",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Sandalwood Tube Beads, Smoky Quartz, Clear Quartz",
    "sizeText": "Beads 10-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Brown, Transparent, Grey",
    "gemstone": "Wood, Quartz",
    "collection": "woodlight",
    "primary": "FS-BR-2607-012__white_bg_product__02__site_selected.png",
    "wear": "FS-BR-2607-012__display__01__site_selected.png",
    "detailImages": [
      "FS-BR-2607-012__white_bg_product__02__site_selected.png",
      "FS-BR-2607-012__wear__03__site_selected.png",
      "FS-BR-2607-012__atmosphere__03__site_selected.png",
      "FS-BR-2607-012__atmosphere__05__site_selected.png",
      "FS-BR-2607-012__display__01__site_selected.png"
    ],
    "oneLineStory": "Smoky brown quartz and clear crystal alternate around a curved sandalwood bead, finished with cool stainless-steel details.",
    "productStory": "Smoky Woodlight brings together three distinct tones: the translucent brown of smoky quartz, the brightness of clear quartz, and the deep grain of a curved sandalwood tube bead. Their contrast gives the bracelet a quiet, grounded presence without making the composition feel heavy.\n\nThe name follows that meeting of smoke, wood, and clear light. Darker elements give the piece visual weight, while transparent quartz opens small intervals of brightness—a balance suited to moments of steadiness with room to see clearly.",
    "materialDescription": "Made with a curved sandalwood tube bead, smoky quartz, clear quartz, and stainless-steel components. The bracelet combines deep brown wood grain with translucent smoky-brown and colourless transparent quartz. Natural variations in wood pattern, quartz colour, transparency, and internal features may differ between pieces.",
    "stateCopy": "Grounding leads this piece, with Clarity as its secondary note. The dark wood and smoky brown quartz hold visual weight and steadiness, while clear quartz introduces brighter, more open intervals within the composition.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-10T06:27:32+00:00",
    "description": "烟褐茶晶与透明白水晶交错，一段弯管檀木沉在其中，烟色、清光与深木相接，安静有底。"
  },
  {
    "sku": "FS-BR-2607-013",
    "featured": true,
    "title": "Red Garden Quartz & Yellow Garden Quartz Bracelet",
    "titleCn": "暖霞碎金",
    "subtitle": "Ember Gold Haze",
    "productNameEn": "Ember Gold Haze",
    "states": [
      "Courage",
      "Grounding"
    ],
    "price": "$129",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Red Garden Quartz, Yellow Garden Quartz, Clear Quartz",
    "sizeText": "Beads 12-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Red, Orange, Yellow, Transparent",
    "gemstone": "Quartz",
    "collection": "red-vein-light",
    "primary": "FS-BR-2607-013__simple_bg_product__02.png",
    "wear": "FS-BR-2607-013__atmosphere__02.png",
    "detailImages": [
      "FS-BR-2607-013__simple_bg_product__02.png",
      "FS-BR-2607-013__atmosphere__02.png",
      "FS-BR-2607-013__atmosphere__01.png",
      "FS-BR-2607-013__poster__01.png"
    ],
    "oneLineStory": "Red, amber-gold, and clear quartz alternate in a warm composition of translucent colour, mineral inclusions, and open light.",
    "productStory": "Ember Gold Haze brings together Red Garden Quartz, Yellow Garden Quartz, and clear quartz in shifting shades of red, amber, gold, and transparency. Dense mineral inclusions sit beside clearer beads, while a larger transparent form opens the composition and keeps the warmer colours from feeling heavy.\n\nThe name follows that balance: red and golden tones appear like scattered evening light moving through clear stone. The piece speaks first to Courage, with Grounding held in its deeper rust-red and amber areas.",
    "materialDescription": "Made with Red Garden Quartz, Yellow Garden Quartz, clear quartz, and stainless-steel components, with beads approximately 12–14 mm. The bracelet combines transparent and translucent quartz with red, orange, and golden internal inclusions. Colour density, transparency, internal pattern, and inclusion placement naturally vary between individual stones.",
    "stateCopy": "Courage leads this piece, with Grounding as its secondary state. Warm red and golden inclusions create concentrated points of colour without overwhelming the clear quartz, while deeper rust and amber tones give the composition a steadier visual base.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T11:49:37+00:00",
    "description": "红胶花的赤红、黄胶花的暖金与透明白水晶交错，暖色像一层散开的霞光落在清透珠体之间。"
  },
  {
    "sku": "FS-BR-2607-016",
    "featured": true,
    "title": "Silver Sheen Obsidian & Obsidian Bracelet",
    "titleCn": "黑曜素环",
    "subtitle": "Obsidian Arc",
    "productNameEn": "Obsidian Arc",
    "states": [
      "Protection",
      "Grounding"
    ],
    "price": "$89",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Silver Sheen Obsidian, Obsidian",
    "sizeText": "Beads 10-12 mm · S–L · Fits wrists 13–18 cm",
    "color": "Black, Grey",
    "gemstone": "Obsidian",
    "collection": "nocturne-cosmos",
    "primary": "FS-BR-2607-016__simple_bg_product__02.png",
    "wear": "",
    "detailImages": [
      "FS-BR-2607-016__simple_bg_product__02.png",
      "FS-BR-2607-016__simple_bg_product__01.png",
      "FS-BR-2607-016__atmosphere__01.png",
      "FS-BR-2607-016__detail__01.png"
    ],
    "oneLineStory": "Curved silver-sheen obsidian forms alternate with glossy black beads, creating a restrained ring of dark metallic light.",
    "productStory": "Obsidian Arc is built from curved silver-sheen obsidian forms separated by smaller black obsidian beads. The bracelet stays almost entirely within black and charcoal grey, while the elongated curves soften the repetition and give the dark composition a more fluid rhythm.\n\nAs the surface catches light, muted silver reflections appear along the larger obsidian forms without breaking the overall restraint. The piece speaks first to Protection, with Grounding held in its weight, repetition, and nearly monochrome palette.",
    "materialDescription": "Made with silver-sheen obsidian and black obsidian in a repeating curved-and-round structure, with beads approximately 10–12 mm alongside larger elongated elements. The palette ranges from glossy black to charcoal grey, with subdued silver surface sheen. Natural differences in tone and sheen may occur between individual stones.",
    "stateCopy": "Protection leads this piece, with Grounding as its secondary state. Deep black obsidian gives the bracelet a contained visual presence, while the repeated curved forms and muted silver sheen keep the composition steady rather than severe.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T13:49:16+00:00",
    "description": "银曜石弯管与黑曜石串成一圈几乎全黑的素环，弯管的弧线让黑色不显死板，转动时有暗银光沿边缘浮起。"
  },
  {
    "sku": "FS-BR-2607-017",
    "featured": true,
    "title": "Lavender Amethyst & Clear Quartz Bracelet",
    "titleCn": "薰衣草雾",
    "subtitle": "Lavender Mist",
    "productNameEn": "Lavender Mist",
    "states": [
      "Unfolding",
      "Soothing"
    ],
    "price": "$109",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Lavender Amethyst, Clear Quartz, Lepidolite",
    "sizeText": "Beads 12-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Purple, Transparent",
    "gemstone": "Quartz, Other",
    "collection": "other",
    "primary": "FS-BR-2607-017__white_bg_product__01__site_selected.png",
    "wear": "FS-BR-2607-017__atmosphere__04__site_selected.png",
    "detailImages": [
      "FS-BR-2607-017__white_bg_product__01__site_selected.png",
      "FS-BR-2607-017__atmosphere__04__site_selected.png",
      "FS-BR-2607-017__atmosphere__01__site_selected.png",
      "FS-BR-2607-017__atmosphere__09__site_selected.png",
      "FS-BR-2607-017__poster__03__site_selected.png"
    ],
    "oneLineStory": "Soft lavender, deeper violet, and clear crystal alternate in a luminous strand with gentle shifts in shape and tone.",
    "productStory": "Lavender Mist layers pale lavender amethyst, deeper lepidolite tones, and clear quartz into a bracelet of soft contrasts. Rounded purple beads meet transparent quartz in both polished rounds and irregular forms, creating a rhythm that feels light rather than uniform.\n\nThe name comes from its restrained wash of colour: lavender and violet seem to drift through the clearer elements like a thin veil of mist. It speaks to Unfolding first, with a quieter sense of Soothing held in its softened palette and spacious transparency.",
    "materialDescription": "Made with lavender amethyst, clear quartz, and lepidolite in a mixed-shape bracelet. The palette ranges from pale lavender and deeper purple to colourless transparency. Clear quartz beads show visible internal fractures and variations, while colour, translucency, and internal features naturally differ between individual stones.",
    "stateCopy": "Unfolding leads this piece, with Soothing as a secondary note. Its pale lavender tones, transparent intervals, and softly varied forms hold a sense of openness, while the deeper violet accents give the composition a quieter, more settled counterpoint.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-10T07:12:11+00:00",
    "description": "薰衣草紫水晶的浅紫、紫锂云母的粉紫与透明白水晶交错，颜色淡、光感柔，像一层薄薄的紫雾被收在清透珠体里。"
  },
  {
    "sku": "FS-BR-2607-018",
    "featured": true,
    "title": "Black Rutilated Quartz & Clear Quartz Bracelet",
    "titleCn": "沉曜星野",
    "subtitle": "Nocturne Orbit",
    "productNameEn": "Nocturne Orbit",
    "states": [
      "Protection",
      "Clarity"
    ],
    "price": "$139",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Black Rutilated Quartz, Clear Quartz, Silver Sheen Obsidian, Smoky Quartz, Obsidian",
    "sizeText": "Beads 12-16 mm · S–L · Fits wrists 13–18 cm",
    "color": "Black, Grey, Transparent, Brown",
    "gemstone": "Quartz, Obsidian",
    "collection": "nocturne-cosmos",
    "primary": "FS-BR-2607-018__white_bg_product__01.png",
    "wear": "FS-BR-2607-018__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2607-018__white_bg_product__01.png",
      "FS-BR-2607-018__simple_bg_product__01.png",
      "FS-BR-2607-018__atmosphere__01.png",
      "FS-BR-2607-018__atmosphere__03.png"
    ],
    "oneLineStory": "Large black and smoky stones meet clear quartz and silver-grey textures in a weighty, planetary composition.",
    "productStory": "Nocturne Orbit brings together Black Rutilated Quartz, Silver Sheen Obsidian, Smoky Quartz, clear quartz, and obsidian in a composition of black, charcoal, smoke brown, and transparency. Large rounded stones are interrupted by faceted and geometric forms, giving the bracelet an irregular, orbit-like rhythm.\n\nThe name follows its dark celestial character: deep stones sit like shadowed planets, while silver sheen, smoky translucency, and clear quartz catch smaller intervals of light. Protection leads the piece, with Clarity appearing through its transparent and reflective details.",
    "materialDescription": "Made with Black Rutilated Quartz, clear quartz, Silver Sheen Obsidian, Smoky Quartz, and obsidian, with beads approximately 12–16 mm. The bracelet combines rounded, faceted, and geometric forms in black, grey, smoky brown, and transparent tones. Sheen, inclusions, transparency, and surface texture naturally vary between stones.",
    "stateCopy": "Protection leads this piece, with Clarity as its secondary state. Deep black and charcoal stones give the composition a contained, substantial presence, while smoky transparency, silver-grey reflections, and clear quartz introduce lighter intervals across the darker structure.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T13:59:17+00:00",
    "description": "黑发晶、黑曜石的深黑大珠与陨石银曜石的银光并置，茶晶的烟褐与透明白水晶穿插其间，像夜空里几颗被照亮的深色行星。"
  },
  {
    "sku": "FS-BR-2607-020",
    "featured": true,
    "title": "Black Gold Super Seven Bracelet",
    "titleCn": "玄金流砂",
    "subtitle": "Dark Gold Drift",
    "productNameEn": "Dark Gold Drift",
    "states": [
      "Clarity",
      "Grounding"
    ],
    "price": "$109",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Black Gold Super Seven",
    "sizeText": "Beads 10-12 mm · S–L · Fits wrists 13–18 cm",
    "color": "Multicolor, Brown, Gold",
    "gemstone": "Quartz",
    "collection": "other",
    "primary": "FS-BR-2607-020__simple_bg_product__01.png",
    "wear": "FS-BR-2607-020__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2607-020__simple_bg_product__01.png",
      "FS-BR-2607-020__wear__01.png",
      "FS-BR-2607-020__atmosphere__01.png",
      "FS-BR-2607-020__atmosphere__03.png"
    ],
    "oneLineStory": "Translucent quartz beads carry red-brown, gold, and charcoal threads, creating a warm, shifting pattern within each sphere.",
    "productStory": "Dark Gold Drift is formed from Black Gold Super Seven, with red-brown, golden, and grey-black inclusions crossing through translucent quartz. Each bead holds a different concentration and direction of fine internal threads, giving the otherwise uniform strand a constantly changing surface.\n\nThe name comes from those darker mineral lines and warmer flashes suspended together, reminiscent of fine sand moving through shadowed light. The piece speaks to Clarity with Grounding beneath it: visually intricate, yet contained within a simple, continuous form.",
    "materialDescription": "Made with Black Gold Super Seven quartz in a uniform round-bead bracelet. The translucent beads contain visible red-brown, golden, and grey-black needle-like and mineral inclusions. Colour, transparency, inclusion density, and internal pattern naturally vary from bead to bead.",
    "stateCopy": "Clarity leads this piece, with Grounding as its secondary note. Transparent quartz keeps the structure visually open, while the dense brown, gold, and dark internal threads add depth and weight—a balance between intricate detail and a restrained overall form.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T03:51:32+00:00",
    "description": "黑金超七里红褐、金色与灰黑的针状内含物交错，透明珠体把它们收在一起，像一片流动的暗色星砂里藏着暖光。"
  },
  {
    "sku": "FS-BR-2607-021",
    "featured": true,
    "title": "Amethyst & Clear Quartz Bracelet",
    "titleCn": "雾紫含光",
    "subtitle": "Violet Mistlight",
    "productNameEn": "Violet Mistlight",
    "states": [
      "Unfolding",
      "Soothing"
    ],
    "price": "$139",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Amethyst, Clear Quartz, Lepidolite",
    "sizeText": "Beads 12-16 mm · S–L · Fits wrists 13–18 cm",
    "color": "Purple, Transparent",
    "gemstone": "Quartz, Other",
    "collection": "other",
    "primary": "FS-BR-2607-021__white_bg_product__01.png",
    "wear": "FS-BR-2607-021__atmosphere__01.png",
    "detailImages": [
      "FS-BR-2607-021__white_bg_product__01.png",
      "FS-BR-2607-021__atmosphere__01.png",
      "FS-BR-2607-021__atmosphere__02.png",
      "FS-BR-2607-021__atmosphere__03.png"
    ],
    "oneLineStory": "Misty violet, smoky purple, and clear stones shift between soft rounded forms, facets, and transparent light.",
    "productStory": "Violet Mistlight layers amethyst, clear quartz, and lepidolite in shades of pale lilac, smoky violet, and transparency. Rounded stones alternate with faceted and irregular forms, while a larger muted-purple focal bead gives the bracelet an intentionally asymmetric point of weight.\n\nThe name follows its softened palette: violet appears almost suspended in mist, with clear quartz opening brighter intervals between the deeper tones. The piece speaks first to Unfolding, with Soothing held in its gentle colour transitions and spacious visual rhythm.",
    "materialDescription": "The design combines amethyst, clear quartz, and lepidolite in approximately 12–16 mm beads alongside larger irregular elements. It includes pale and deeper violet tones, transparent quartz, rounded beads, and faceted forms. Colour, transparency, internal features, and surface appearance may naturally vary between individual stones.",
    "stateCopy": "Unfolding leads this piece, with Soothing as its secondary state. Soft violet tones and clear quartz create an open, unhurried composition, while the deeper smoky-purple elements provide gentle contrast without making the bracelet feel visually heavy.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T14:14:47+00:00",
    "description": "灰紫、粉紫的紫水晶与紫锂云母，配上透明白水晶和一两颗深色矿珠，紫调偏雾、偏柔，像一层淡紫烟被清光托着。"
  },
  {
    "sku": "FS-BR-2607-022",
    "featured": true,
    "title": "Sandalwood Tube Beads & Clear Quartz Bracelet",
    "titleCn": "素檀清光",
    "subtitle": "Sandalwood Arc",
    "productNameEn": "Sandalwood Arc",
    "states": [
      "Grounding",
      "Clarity"
    ],
    "price": "$89",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Sandalwood Tube Beads, Clear Quartz",
    "sizeText": "Beads 10-12 mm · S–L · Fits wrists 13–18 cm",
    "color": "Brown, Transparent",
    "gemstone": "Wood, Quartz",
    "collection": "woodlight",
    "primary": "FS-BR-2607-022__white_bg_product__01.png",
    "wear": "",
    "detailImages": [
      "FS-BR-2607-022__white_bg_product__01.png",
      "FS-BR-2607-022__atmosphere__01.png",
      "FS-BR-2607-022__detail__01.png",
      "FS-BR-2607-022__poster__01.png"
    ],
    "oneLineStory": "Deep curved sandalwood forms alternate with clear quartz, creating a bold, minimal rhythm of warm wood and light.",
    "productStory": "Sandalwood Arc reduces the bracelet to two contrasting elements: substantial curved sandalwood forms and clear quartz. The dark wooden arcs define its silhouette, while transparent beads interrupt the continuous brown line with small intervals of light.\n\nIts name follows the structure itself. Broad curves of wood form a quiet circular rhythm, with clear quartz appearing between them like morning light resting on a simple wooden surface. The piece speaks first to Grounding, with Clarity held in its open, transparent contrasts.",
    "materialDescription": "Made with curved sandalwood tube beads and clear quartz in a repeating mixed-form bracelet. The design combines substantial brown wooden elements with transparent round quartz beads. Natural variation may appear in wood colour, grain, surface markings, quartz transparency, and internal features.",
    "stateCopy": "Grounding leads this piece, with Clarity as its secondary state. The broad sandalwood arcs give the bracelet visual weight and a steady rhythm, while transparent quartz creates clean intervals of light within the darker wooden structure.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T14:50:08+00:00",
    "description": "大体量的弯管檀木围成简洁的深色弧线，几颗透明白水晶点在其间，木色沉、水晶清，像晨光落在一段素净的木上。"
  },
  {
    "sku": "FS-BR-2607-023",
    "featured": false,
    "title": "Golden Rutilated Quartz & Gold Foil Garden Quartz Bracelet",
    "titleCn": "蜜金流光",
    "subtitle": "Honeygold Glow",
    "productNameEn": "Honeygold Glow",
    "states": [
      "Clarity",
      "Grounding"
    ],
    "price": "$139",
    "availability": "Available",
    "replicable": "Yes",
    "type": "bracelet",
    "materials": "Golden Rutilated Quartz, Gold Foil Garden Quartz",
    "sizeText": "Beads 10-14 mm · S–L · Fits wrists 13–18 cm",
    "color": "Gold, Yellow, Transparent",
    "gemstone": "Quartz",
    "collection": "other",
    "primary": "FS-BR-2607-023__white_bg_product__01.png",
    "wear": "FS-BR-2607-023__atmosphere__02.png",
    "detailImages": [
      "FS-BR-2607-023__white_bg_product__01.png",
      "FS-BR-2607-023__atmosphere__02.png",
      "FS-BR-2607-023__atmosphere__01.png",
      "FS-BR-2607-023__poster__01.png"
    ],
    "oneLineStory": "Golden threads, warm foil-like inclusions, and clear honey tones move through a bracelet of varied quartz forms.",
    "productStory": "Honeygold Glow brings together Golden Rutilated Quartz and Gold Foil Garden Quartz in a restrained spectrum of gold, pale yellow, and transparent brown. Fine thread-like inclusions run through the rutilated quartz, while warmer clustered details create brighter points among the rounded beads and small faceted accents.\n\nThe name follows this continuous golden light, as if a soft honey-coloured glow had settled inside the quartz. The piece speaks first to Clarity, with Grounding held in its warmer, deeper golden tones.",
    "materialDescription": "Made with Golden Rutilated Quartz and Gold Foil Garden Quartz, with beads approximately 10–14 mm. The bracelet combines rounded quartz, smaller faceted accents, and a geometric focal form. Visible inclusions range from fine golden threads to denser warm-toned formations, with natural variation in colour, transparency, and internal pattern.",
    "stateCopy": "Clarity leads this piece, with Grounding as its secondary state. Fine golden threads and transparent quartz keep the composition visually open, while the honey-gold and deeper amber tones add warmth, density, and a steadier counterpoint.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T15:23:59+00:00",
    "description": "金发晶的金色针丝与金箔胶花的暖金光点交错，整串金棕色阶统一，像蜜色阳光被收进晶体里。"
  },
  {
    "sku": "FS-TW-2607-002",
    "featured": true,
    "title": "Phantom Quartz Necklace",
    "titleCn": "层峦含金",
    "subtitle": "Layered Golden Ridges",
    "productNameEn": "Layered Golden Ridges",
    "states": [
      "Grounding",
      "Clarity"
    ],
    "price": "$899",
    "availability": "Available",
    "replicable": "No",
    "type": "necklace",
    "materials": "Phantom Quartz",
    "sizeText": "Size pending",
    "color": "Multicolor, Green, Gold, Transparent",
    "gemstone": "Quartz",
    "collection": "three-thousand-worlds",
    "primary": "FS-TW-2607-002__white_bg_product__01.png",
    "wear": "FS-TW-2607-002__wear__02.png",
    "detailImages": [
      "FS-TW-2607-002__white_bg_product__01.png",
      "FS-TW-2607-002__wear__02.png",
      "FS-TW-2607-002__wear__01.png",
      "FS-TW-2607-002__display__01.png"
    ],
    "oneLineStory": "A large transparent phantom quartz centerpiece holds green, gold, and deep brown inclusions like layered terrain beneath open sky.",
    "productStory": "Layered Golden Ridges centers on a large trapezoid of phantom quartz, where green, warm gold, and deep brown inclusions gather across the lower half of the crystal. Above them, a broad clear section leaves the internal landscape open and spacious.\n\nThe name follows that natural composition: overlapping mineral forms resemble distant ridges, mossed slopes, and sunlit earth held inside transparent quartz. The piece speaks first to Grounding, with Clarity reflected in the generous clear space surrounding its denser internal landscape.",
    "materialDescription": "The focal piece is phantom quartz with a transparent body and visible green, golden, brown, grey, and pale mineral inclusions concentrated into layered internal formations. Its irregular trapezoid form and scenic pattern are unique to this stone. Colour placement, transparency, inclusions, and internal structure are naturally individual.",
    "stateCopy": "Grounding leads this piece, with Clarity as its secondary state. The dense, earth-toned landscape gives the crystal visual weight, while the large transparent area above it creates an expansive contrast between layered depth and open space.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T11:24:38+00:00",
    "description": "梯形透明晶体的下方展开一片完整的山原景观：青绿的苔色、橘金的暖光与深褐的岩土层层堆叠，上方留出大片清透的天空。"
  },
  {
    "sku": "FS-TW-2607-008",
    "featured": true,
    "title": "Copper Rutilated Quartz Necklace",
    "titleCn": "铜砂石野",
    "subtitle": "Copper Sand Wilds",
    "productNameEn": "Copper Sand Wilds",
    "states": [
      "Courage",
      "Grounding"
    ],
    "price": "$799",
    "availability": "Available",
    "replicable": "No",
    "type": "necklace",
    "materials": "Copper Rutilated Quartz",
    "sizeText": "Size pending",
    "color": "Red, Brown, Transparent",
    "gemstone": "Quartz",
    "collection": "three-thousand-worlds",
    "primary": "FS-TW-2607-008__white_bg_product__01.png",
    "wear": "FS-TW-2607-008__poster__02__site_selected.png",
    "detailImages": [
      "FS-TW-2607-008__white_bg_product__01.png",
      "FS-TW-2607-008__atmosphere__01__site_selected.png",
      "FS-TW-2607-008__poster__02__site_selected.png",
      "FS-TW-2607-008__poster__04__site_selected.png"
    ],
    "oneLineStory": "A clear rectangular quartz pendant holds scattered copper-red and brown inclusions, suspended beneath a strand of softly mottled beads.",
    "productStory": "Copper Sand Wilds centers on a transparent rectangular pendant filled with scattered copper-red and brown inclusions. Their density shifts across the stone, gathering into warmer, darker areas before thinning into clearer space, while the beaded strand echoes the same muted earth tones.\n\nThe name follows that internal terrain: fine copper-coloured particles appear suspended like warm mineral sand across an open field of quartz. The piece speaks first to Courage, with Grounding held in its earthy palette and concentrated internal forms.",
    "materialDescription": "The focal pendant is Copper Rutilated Quartz with a transparent body and visible red-brown and copper-toned inclusions in varying densities. The rectangular form has faceted upper edges and a polished surface. As a one-of-one piece, the placement, concentration, colour, and structure of its natural inclusions are individual to this stone.",
    "stateCopy": "Courage leads this piece, with Grounding as its secondary state. Warm copper and red-brown inclusions create points of visual intensity within clear quartz, while their earthy tones and denser lower formations give the composition a steadier, more anchored presence.",
    "copyStatus": "Reviewed",
    "copyReviewedAt": "2026-08-11T11:35:01+00:00",
    "description": "长方形透明晶体里散着红褐、铜色的碎点内含物，像撒在清透石中的一片赤色星砂，疏密不一，暖色点点浮动。"
  }
];
